import React from 'react';
import { Button, Modal, Spinner } from 'react-bootstrap';

interface ModalBotaoProps {
  content: string;
  onClick: React.MouseEventHandler<HTMLButtonElement>;
  variant?: string;
}

export interface AlertModalProps {
  show: boolean;
  onHide: () => void;
  title: string;
  body: React.ReactElement | string;
  botaoCancelar?: ModalBotaoProps;
  botaoOk: ModalBotaoProps;
  isLoading?: boolean;
  loadingMessage?: string;
}

const AlertModal: React.FC<AlertModalProps> = ({
  show,
  onHide,
  title,
  body,
  botaoCancelar = { content: 'Cancelar', onClick: onHide, variant: 'secondary' },
  botaoOk,
  isLoading = false,
  loadingMessage = 'Carregando...'
}) => {

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {body}
      </Modal.Body>
      <Modal.Footer>
        <Button variant={botaoCancelar?.variant ?? 'primary'} onClick={botaoCancelar?.onClick} disabled={isLoading}>
          {botaoCancelar?.content}
        </Button>
        <Button variant={botaoOk.variant ?? 'primary'} onClick={botaoOk.onClick} autoFocus={true} disabled={isLoading}>
          {isLoading ? (
            <>
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
              />{' '}
              {loadingMessage}
            </>
          ) : (
            <>{ botaoOk.content }</>
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AlertModal;
